import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

// make a container that render at the center of the screen
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  padding-bottom: 40px;
`;

export const InfoSpecialContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  width: 568px;
  padding: 60px 42px;
  padding-top: 0;
  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }

  p {
    font-size: 14px;
    color: ${theme.colours.gray4};
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
    line-height: 22px;
    color: #000000;
  }

  .reservation-title {
    font-size: 14px;
    margin-bottom: 8px !important;
    color: ${theme.colours.gray4};
  }

  .success-footer {
    text-align: center;
    margin: 32px 0;
    color: ${theme.colours.gray4};
    font-size: 13px;
    line-height: 17px;
    a {
      cursor: pointer;
      text-decoration: none;
    }
  }
  .backBtn {
    background-color: ${theme.colours.mainBlue};
    color: white;
    cursor: pointer;
    border-radius: 12px;
    font-size: 14px;
    padding: 7px 25px;
    font-family: Regular, sans-serif;
    border: none;
    line-height: 22px;
    text-align: center;
    width: fit-content;
  }
`;

// create a conainter that will contain a title and an info div with two button at the bottom
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${theme.colours.white};
  border-radius: 12px;
  padding: 32px;
  gap: 24px;
  width: 500px;
  @media (max-width: 500px) {
    width: 100%;
  }

  .learnMore {
    color: #000000;
  }

  @media (max-width: 768px) {
    padding: 16px;
  }

  h1 {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    font-family: ${theme.fonts.SemiBold};
    color: #000000;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
    color: #000000;
  }

  .success-footer {
    text-align: center;
    color: ${theme.colours.black};
    font-size: 13px;
    line-height: 17px;
    a {
      cursor: pointer;
      text-decoration: none;
    }
  }
  .backBtn {
    background-color: ${theme.colours.mainBlue};
    color: white;
    border-radius: 12px;
    font-size: 14px;
    cursor: pointer;
    padding: 7px 25px;
    font-family: Regular, sans-serif;
    border: none;
    line-height: 22px;
    text-align: center;
    width: fit-content;
  }
  .infoWrapper {
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid rgb(225, 225, 225);
    .space {
      margin-right: 4px;
    }
    h3 {
      font-size: 16px;
      font-weight: 400;
      line-height: 27px;
      color: #000000;
      font-family: ${theme.fonts.Regular};
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #000000;
      font-family: ${theme.fonts.Regular};
    }
    .meeting-info {
      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #000000;
        font-family: ${theme.fonts.Regular};
      }
    }
  }

  .cancel-reason-container {
    padding-bottom: 24px;
    border-bottom: 1px solid ${theme.colours.BrightGray};
    label {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 4px;
      padding-right: 12px;
      font-family: ${theme.fonts.Regular};
      color: #000000;
    }
    input {
      border: 1px solid rgb(200, 200, 200);
      border-radius: 8px;
      padding: 6px 12px;
      height: 40px;
      width: 100%;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      font-family: ${theme.fonts.Regular};
      outline: none;

      &:focus {
        border: 1px solid ${theme.colours.BrightGray};
      }
    }
    button {
      height: 40px;
      width: 100%;
      background-color: #000000;
      color: white;
      border-radius: 8px !important;
      font-size: 14px !important;
      font-weight: 400;
      line-height: 20px;
      font-family: ${theme.fonts.Regular};
    }
  }
`;

// create a div that display the button in flex with space between but in mobile mod it will wrap and display in column
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  border: 1px solid rgb(225, 225, 225);
  border-radius: 8px;
  height: 61px;
  width: 100%;

  .actb-initialized {
    width: 100% !important;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    font-family: ${theme.fonts.Regular};
  }
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  gap: 1rem;
  background-color: ${theme.colours.mainBlue};
  color: white;
  border-radius: 12px;
  align-items: center;
  width: 100%;
  height: 60px;
  font-size: 14px;
`;

export const AddToCalendarButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  height: 30px !important;
`;

export const AddToCalendarLink = styled.a`
  background: transparent;
  border: none;
  cursor: pointer;
  height: 30px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
`;
